<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="appointmentOrderVO.pkid > 0 ? '编辑' : '新建'"
      class="appointmentOrder-edit"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="appointmentOrderVO"
        :rules="ruleValidate"
        class="form"
        label-width="90px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="系统编号">
            <el-input v-model="appointmentOrderVO.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="登记日期">
            <el-date-picker
                v-model="appointmentOrderVO.creatTime"
                style="width: 190px"
                type="datetime"
                disabled
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="登记人">
            <el-input v-model="appointmentOrderVO.creatorName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预约日期">
            <el-date-picker
                v-model="appointmentOrderVO.appointmentTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="appointmentOrderVO.customerName" readonly placeholder="请输入" clearable>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectCustomer.open()">选择</el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="客户类型">
            <el-select v-model="appointmentOrderVO.customerType">
              <el-option label="直销" value="直销"/>
              <el-option label="经销" value="经销"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售员">
            <el-input v-model="appointmentOrderVO.salesmanName" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectSalesman.open()"/>
            </el-input>
            <user-select ref="selectSalesman" @select="selectSalesman"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="销售联系方式">
            <el-input v-model="appointmentOrderVO.salesMobile"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="出厂编号">
            <el-input v-model="appointmentOrderVO.factoryNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="现场名称">
            <el-input v-model="appointmentOrderVO.siteName"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="现场联系人">
            <el-input v-model="appointmentOrderVO.contact"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="现场联系方式">
            <el-input v-model="appointmentOrderVO.siteMobile"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="项目负责人">
            <el-input v-model="appointmentOrderVO.projectLeader"/>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item label="服务地址" prop="serviceAddress">
            <el-input v-model="appointmentOrderVO.serviceAddress"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="设备/行业">
        <el-radio-group v-model="appointmentOrderVO.equipmentType">
          <el-radio label="3C电子">3C电子</el-radio>
          <el-radio label="半导体">半导体</el-radio>
          <el-radio label="光伏/锂电">光伏/锂电</el-radio>
          <el-radio label="机床/激光">机床/激光</el-radio>
          <el-radio label="火花机/线切割">火花机/线切割</el-radio>
          <el-radio label="包装/印刷">包装/印刷</el-radio>
          <el-radio label="纺织">纺织</el-radio>
          <el-radio label="机器人">机器人</el-radio>
          <el-radio label="物流">物流</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="产品类型" prop="appointmentItems3">
        <el-checkbox-group v-model="appointmentOrderVO.appointmentItems3">
          <el-checkbox v-for="item in appointmentItemTemplates3" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div class="vm-separate">
        <el-form-item label="服务性质" prop="appointmentItems1">
          <el-checkbox-group v-model="appointmentOrderVO.appointmentItems1" @change="natureTypeChange">
            <el-checkbox v-for="item in appointmentItemTemplates1" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="appointmentOrderVO.appointmentItems1.length>0 && appointmentOrderVO.appointmentItems1.toString().includes('其他')" label="其他性质">
          <el-input v-model="appointmentOrderVO.natureNote" placeholder="请输入"/>
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="6">
          <el-form-item label="服务台数" prop="serviceQuantity">
            <el-input v-model="appointmentOrderVO.serviceQuantity"/>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="主板型号" prop="mainBoardModel">
            <el-input v-model="appointmentOrderVO.mainBoardModel"/>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="变频器型号" prop="transducerModel">
            <el-input v-model="appointmentOrderVO.transducerModel"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vm-separate">
        <el-form-item label="服务原因" prop="appointmentItems2">
          <el-checkbox-group v-model="appointmentOrderVO.appointmentItems2">
            <el-checkbox v-for="item in appointmentItemTemplates2" :key="item.pkid" :label="item.itemName">{{item.itemName}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
      <el-form-item v-if="appointmentOrderVO.appointmentItems2.length>0 && appointmentOrderVO.appointmentItems2.toString().includes('其他')" label="其他原因">
        <el-input v-model="appointmentOrderVO.causeNote" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="故障描述" prop="faultNote">
        <el-input
            v-model="appointmentOrderVO.faultNote"
            placeholder="维修必填"
            type="textarea"
            max="150"/>
      </el-form-item>
      <div>
        <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
        <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="appointmentOrderVO.attachments"
            ref="payData1"
            :data="appointmentOrderVO.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.fileName" class="tabInput" style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>
 
<script>
  // import constants from "../../../util/constants";
  import loginUtil from "@/util/loginUtil";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import UploadFile from "@/components/UploadFile";

  export default {
    name: "AppointmentEdit",
    components: {UploadFile, UserSelect, CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        salesmanList:[],
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        appointmentItemTemplates3: [],
        appointmentOrderVO: {
          pkid: "",
          billNo: "",
          creatTime: "",
          appointmentTime: "",
          creatorName: loginUtil.getName(),
          customerId: "",
          customerName: "",
          customerType: "",
          equipmentType: "",
          productType: "",
          salesmanId: "",
          salesMobile: "",
          salesOrderNo: "", //出厂编号
          siteName: "",
          salesmanName: "",
          departmentName: "",
          contact: "",
          siteMobile: "",
          natureNote: "",
          projectLeader: "",
          serviceAddress: "", //服务地址
          serviceQuantity: "", //服务台数
          submitTime: "", //提交日期
          addComment: "", //审核意见
          mainBoardModel: "",
          transducerModel: "",
          causeNote: "",
          faultNote: "",
          attachments: [],
          delayTableData: [],
          appointmentItems1: [],
          appointmentItems2: [],
          appointmentItems3: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空",trigger: "blur"},
          salesmanName: {required: true, message: "不能为空",trigger: "blur"},
          factoryNo: {required: true, message: "不能为空",trigger: "blur"},
          siteName: {required: true, message: "不能为空",trigger: "blur"},
          contact: {required: true, message: "不能为空",trigger: "blur"},
          siteMobile: {required: true, message: "不能为空",trigger: "blur"},
          serviceAddress: {required: true, message: "不能为空",trigger: "blur"},
          appointmentItems1: {required: true, message: "不能为空",trigger: "blur"},
          appointmentItems2: {required: true, message: "不能为空",trigger: "blur"},
          serviceQuantity: {required: true, message: "不能为空",trigger: "blur"},
          mainBoardModel: {required: true, message: "不能为空",trigger: "blur"},
          transducerModel: {required: true, message: "不能为空",trigger: "blur"},
          faultNote: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.appointmentOrderVO.pkid = row.pkid;
          if(this.appointmentOrderVO.pkid>0) {
            this.getData();
          }
        }
        this.getTemplateList();
      },
      getData() {
        this.$http
          .get("basic", `appointmentOrders/${this.appointmentOrderVO.pkid}`)
          .then(resp => {
            this.appointmentOrderVO = resp.data;
            console.log(this.appointmentOrderVO);
            this.appointmentOrderVO.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          });
      },
      fileDelete(row,index) {
        this.appointmentOrderVO.attachments.splice(index, 1);
      },
      getTemplateList() {
        this.$http
          .get("basic", "appointmentItemTemplates/getAllList")
          .then(resp => {
            this.appointmentItemTemplates1 = [];
            this.appointmentItemTemplates2 = [];
            resp.data.forEach(item=>{
              if (item.itemType === 10) {
                this.appointmentItemTemplates1.push(item);
              }else if (item.itemType === 20) {
                this.appointmentItemTemplates2.push(item);
              }else {
                this.appointmentItemTemplates3.push(item);
              }
            });
          });
      },
      natureTypeChange(value) {
        console.log(value);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.appointmentOrderVO.attachments.push(params);
        }
      },
      selectCustomer(row) {
        console.log(row);
        this.appointmentOrderVO.customerName = row.customerName;
        this.appointmentOrderVO.customerId = row.customerID;
      },
      selectSalesman(item) {
        this.appointmentOrderVO.salesmanId = item.systemUserID;
        this.appointmentOrderVO.salesmanName = item.employeeName;
        this.appointmentOrderVO.departmentName = item.departmentName;
        this.appointmentOrderVO.salesMobile = item.mobile;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.appointmentOrderVO.isSubmit = false;
            console.log(this.appointmentOrderVO);
            if(this.appointmentOrderVO.pkid>0) {
              this.$http
                .put("basic", "appointmentOrders", this.appointmentOrderVO)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "appointmentOrders", this.appointmentOrderVO)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>